import React from 'react'

const EditCategory = () => {
    return (
        <div>
            
        </div>
    )
}

export default EditCategory
